import React, {useEffect, useState} from 'react';
import {BuildingBaseData, BuildingData} from "../../index";
import BuildingCategories from "./BuildingCategories";
import BuildingDetails from "./BuildingDetails";
import {BuildingOverviewConfiguration} from "./index";
import ImageBuilding from "../ImageBuilding/ImageBuilding";
import WithTooltip, {TooltipLocation} from "../../../react/components/ui/withTooltip";
import {useTranslationContext} from "../../../react/providers/TranslationContext";
import './index.sass';

type Props = {
    getBuildingData: (gid: number) => Promise<BuildingData>,
    getBuildingBaseData: () => Promise<BuildingBaseData[]>,
    selectedBuilding?: number,
    setSelectedBuilding: (gid: null|number) => void,
};

export default function BuildingOverview({ getBuildingBaseData, getBuildingData, setSelectedBuilding, selectedBuilding = null }: Props) {
    const [ data, setData ] = useState<null|BuildingBaseData[]>(null);
    const [ hoverBuilding, setHoverBuilding ] = useState<null|BuildingBaseData>(null);
    const [ speed, setSpeed ] = useState<number>(1);
    const [ mainBuilding, setMainBuilding ] = useState<number>(1);

    const {translate, language} = useTranslationContext();

    useEffect(() => {
        getBuildingBaseData().then(data => setData(data));
    })

    if (data === null) {
        return <>Loading</>;
    }

    const config = {
        speed: speed,
        mainBuilding: mainBuilding,
        tribe: null,
    } as BuildingOverviewConfiguration;

    return <div className='travianBuildingOverview' data-language={language}>
        <div className='d-grid align-items-center gap-10 mb-5' style={{ gridTemplateColumns: '250px auto 1fr' }}>
            <div className='d-grid gap-2' style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
                { [1, 2, 3, 5, 10].map(_speed =>
                    <button key={_speed} className={'btn' + (_speed === speed ? ' btn-primary' : '')} onClick={() => setSpeed(_speed)}>{_speed}x</button>) }
            </div>
            <div className='d-grid align-items-center gap-2' style={{ gridTemplateColumns: 'auto 1fr' }}>
                <WithTooltip tooltip={translate('settings_mainBuildingLevel')} location={TooltipLocation.BOTTOM}><ImageBuilding gid={15} size={32} /></WithTooltip>
                <input onChange={e => setMainBuilding(e.target.valueAsNumber)}
                       onFocus={e => e.target.select()}
                       className='mainBuildingInput text-center'
                       type='number' min={0} max={20} step={1} value={mainBuilding} />
            </div>
            <div />
        </div>
        { selectedBuilding === null && <BuildingCategories data={data} hoverBuilding={hoverBuilding} setHoverBuilding={setHoverBuilding} setSelectedBuilding={setSelectedBuilding} /> }
        { selectedBuilding !== null && <BuildingDetails config={config} gid={selectedBuilding} setSelectedBuilding={setSelectedBuilding} getBuildingData={getBuildingData} /> }
    </div>
}
